import React from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
//import SocialMedia from "../../components/socialMedia/SocialMedia";
import BlogsImg from "./BlogsImg";
import { Fade } from "react-reveal";
import "./ContactComponent.css";
import { contactPageData } from "../../portfolio.js";

const ContactData = contactPageData.contactSection;

function Contact(props) {
  const theme = props.theme;

  return (
    <div className="contact-main">
      <Header theme={theme} setTheme={props.setTheme} />
      <div className="basic-contact">
        <Fade bottom duration={1000} distance="40px">
          <div className="contact-heading-div">
            <div className="contact-heading-img-div">
              <BlogsImg theme={theme} />
            </div>
            <div className="contact-heading-text-div">
              <h1
                className="contact-heading-text"
                style={{ color: theme.text }}
              >
                {ContactData["title"]}
              </h1>
              <p
                className="contact-header-detail-text subTitle"
                style={{ color: theme.secondaryText }}
              >
                If you need any assistance or have questions, please feel free to contact us, we will be gladly to server you.
              </p>
              <p
                className="subTitle"
                style={{ color: theme.secondaryText }}
              >
                From the USA & CANADA 011 52 (232) 324 0089
              </p>
              <p
                className="subTitle"
                style={{ color: theme.secondaryText }}
              >
                Direct or within Mexico +52 (232) 324 0089
              </p>
              <p
                className="subTitle"
                style={{ color: theme.secondaryText }}
              >
                Rest of the World +52 (232) 324 0089
              </p>
              <p
                className="contact-header-detail-text subTitle"
                style={{ color: theme.secondaryText }}
              >
                Address:
              </p>
              <p
                className="subTitle"
                style={{ color: theme.secondaryText }}
              >
                Libramiento S/N Martínez de la Torre, CP 93600, Veracruz, México.
              </p>
            </div>
          </div>
        </Fade>
        <Fade bottom duration={1000} distance="40px">
          <div className="blog-heading-div">
            <iframe title="Map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14989.28582259129!2d-97.05795675516127!3d20.078844947126495!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85db023900152df9%3A0x768350fa568cacfe!2sSAN%20GABRIEL!5e0!3m2!1sen!2smx!4v1700275186858!5m2!1sen!2smx" width="100%" height="450" style={{ border: 0 }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

          </div>
        </Fade>
      </div>
      <Footer theme={props.theme} onToggle={props.onToggle} />
    </div>
  );
}

export default Contact;
